// @flow

export const minBy = <T>(
  array: $ReadOnlyArray<T>,
  by: T => number,
): T | null => {
  if (array.length === 0) {
    return null;
  }
  return array.reduce((a, b) => {
    const _1 = by(a);
    const _2 = by(b);
    return _1 < _2 ? a : b;
  });
};

export const maxBy = <T>(
  array: $ReadOnlyArray<T>,
  by: T => number,
): T | null => {
  if (array.length === 0) {
    return null;
  }
  return array.reduce((a, b) => {
    const _1 = by(a);
    const _2 = by(b);
    return _1 > _2 ? a : b;
  });
};
